<template>
  <div class="w-full h-full flex justify-center items-center -mt-8 text-center">
    <div>
      <aha-icon name="no-result" maintain-color class="mb-8" />
      <p class="mb-2 font-bold text-base-90 text-base" v-if="type === 'template'">
        {{ $i18nPresenter.t("No templates match your search!") }}
      </p>
      <p class="mb-4 text-base-80 text-base font-normal" v-if="type === 'template'">
        {{ $i18nPresenter.t("Sorry about that, but you can request it and we might make it in the future!") }}
      </p>
      <p class="mb-4 text-base-80 text-base font-normal" v-if="type === 'slide'">
        {{ $i18nPresenter.t("Sorry, we couldn't find any results matching") }} "{{ keyword }}"
      </p>
      <div>
        <aha-button
          class="font-bold w-44"
          variant="base"
          @click="request()"
          :submitting="submitting"
          :disabled="submitting || isComplete"
        >
          <span v-if="!isComplete">
            <span v-if="type === 'template'">{{ $i18nPresenter.t("Request template") }}</span>
            <span v-if="type === 'slide'">{{ $i18nPresenter.t("Request slide") }}</span>
          </span>
          <span v-else>{{ $i18nPresenter.t("Requested") }}</span>
        </aha-button>
        <aha-button class="font-bold w-44 ml-3" v-if="type === 'slide'" @click="createYourOwn">
          {{ $i18nPresenter.t("Create your own") }}
        </aha-button>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/util'
import ApiTemplate from '@/api/template'
import EventBus from '@/eventBus'

export default {
  components: {
  },
  props: {
    keyword: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'template',
    },
  },
  data() {
    return {
      isComplete: false,
      submitting: false,
    }
  },
  mounted() {
  },
  methods: {
    async request() {
      if (this.submitting) return
      this.submitting = true
      try {
        await ApiTemplate.requestTemplate({
          keyword: this.keyword,
          type: this.type,
        })
        utils.showToastSuccess(this.$i18nPresenter.t('Thanks for your template request!'))
        this.isComplete = true
        this.submitting = false
        this.$emit('request')
        if (this.type === 'slide') {
          utils.mixpanelTracking(
            'Slide Template',
            'Slide Template > Request slide',
            this.keyword,
          )
          EventBus.$emit('slide-search-popup:close')
        } else {
          utils.mixpanelTracking(
            'Templates',
            'Templates > Request template',
            this.keyword,
          )
        }
      } catch {
        this.$emit('request')
      }
    },

    createYourOwn() {
      EventBus.$emit('slide-search-popup:close')
      utils.mixpanelTracking(
        'Slide Template',
        'Slide Template > Create Your Own',
        this.keyword,
      )
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
